export const JSON_ONE2NW = {
   
    "txn_response": {
        "ag_id": "paygate",
        "me_id": "202307200003",
        "order_no": "TESTry44",
        "amount": "1070.50",
        "country": "ARE",
        "currency": "AED",
        "txn_date": "2023-08-12",
        "txn_time": "15:09:48.0",
        "ag_ref": "1091365131269804497",
        "pg_ref": "123456789",
        "status": "Successful",
        "res_code": "0",
        "res_message": "Successful",
        "bank_response": ""
        },
        "pg_details": {
        
        "pg_id": "64646b7048c64689e99ecd3b",
        "pg_name": "MPGS",
        "paymode": "CC"
        },
        "fraud_details": {
        },
        "other_details": {
        "udf1": "",
        "udf2": "",
        "udf3": "",
        "udf4": "",
        "udf5": "",
        "udf6": "",
        "udf7": ""
        }
        
  
        }